import {AnalyticsService} from 'src/analytics';

import {ANALYTICS_SCHEDULER_EVENTS} from '../../analytics/analytics-event-names';
import {shouldSkipSequentialAnalytics} from '../../analytics/analytics-events';

import type {IRootMachineContext} from './rootMachine.types';
import {getTimeUntilMeetingHours} from '../../utils/analytics';
import type {IEvent} from '../../types/IEvent';


export function trackRootCancelMeetingInitiated(
  context: IRootMachineContext,
): void {
  if (shouldSkipSequentialAnalytics(context)) {
    return;
  }
  const event = context.eventDetails as IEvent;
  AnalyticsService.track(ANALYTICS_SCHEDULER_EVENTS.CANCEL_MEETING_INITIATED, {
    template_type: context.eventTemplate?.distribution_rule,
    meeting_date: event?.event_start,
    cancellation_source: context.cancellationSource ?? 'confirmation_email',
    time_until_meeting_hours: getTimeUntilMeetingHours(
      event?.event_start,
      context.timezone,
    ),
  });
}

export function trackRootCancelMeetingConfirmed(
  context: IRootMachineContext,
): void {
  if (shouldSkipSequentialAnalytics(context)) {
    return;
  }
  const event = context.eventDetails as IEvent;
  AnalyticsService.track(ANALYTICS_SCHEDULER_EVENTS.CANCEL_MEETING_CONFIRMED, {
    template_type: context.eventTemplate?.distribution_rule,
    meeting_date: event?.event_start,
    cancellation_source: context.cancellationSource ?? 'confirmation_email',
    reason: context.reason,
  });
}

export function trackRootRescheduleMeetingInitiated(
  context: IRootMachineContext,
): void {
  if (shouldSkipSequentialAnalytics(context)) {
    return;
  }
  const event = context.eventDetails as IEvent;
  AnalyticsService.track(
    ANALYTICS_SCHEDULER_EVENTS.RESCHEDULE_MEETING_INITIATED,
    {
      template_type: context.eventTemplate?.distribution_rule,
      reschedule_resource: context.rescheduleSource ?? 'confirmation_email',
      original_meeting_date: event?.event_start,
      time_until_meeting_hours: getTimeUntilMeetingHours(
        event?.event_start,
        context.timezone,
      ),
    },
  );
}

export const rootMachineAnalyticsActions = {
  trackCancelMeetingInitiated: ({context}: {context: IRootMachineContext}) =>
    trackRootCancelMeetingInitiated(context),
  trackCancelMeetingConfirmed: ({context}: {context: IRootMachineContext}) =>
    trackRootCancelMeetingConfirmed(context),
  trackRescheduleMeetingInitiated: ({
    context,
  }: {
    context: IRootMachineContext;
  }) => trackRootRescheduleMeetingInitiated(context),
};
